/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'faction/ark': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M67.543 97.873L120.063 26H93.311L67.543 61.264zM64.996 26L38.315 62.513v35.36l27.228-37.262V26zM67.543 26v31.874L90.833 26zM10 26v71.873L36.315 61.86V26zM38.315 26v33.123L62.519 26z"/>'
  }
})
